const initialState = {

  isFetchingPostJugdementForm: false,
  isFetchingGetJugdementFormData: false,
  isFetchingAreYouPetitioner: false,
  isFetchingSpouseMilitaryMember: false,
  isFetchingRespondentAppears: false,
  isFetchingFinalDeclarations: false,
  isFetchingAmendPetition: false,
  isFetchingEventHappnedFirst: false,
  isFetchingWhichFiling: false,
  isFetchingDissolveMarriage: false,
  isFetchingMinorChildAgreement: false,
  isFetchingSpousalSupportMSA: false,
  isFetchingChangeFormerName: false,
  isFetchNumberPagesAttached: false,

  spouseMilitaryMember: -1,
  numberPagesAttached: '',

  respondentAppears: {
    respondentAppearsStatus: -1,
    respondentAppearsNo: {
      divorcePurposeStatus: -1,
      divorcePurposeNo: {
        startOverInterviewStatus: -1,
        startOverInterviewNo: {
          settlementAgreementStatus: -1,
          settlementAgreementNo: {
            legalProfessionalStatus: -1,
          },
        },
      },
    },
  },

  finalDeclarations: -1,

  amendPetition: -1,

  eventHappnedFirst: {
    eventHappnedFirstStatus: -1,
    respondentServed: {
      respondentServedDate: "",
    },
    respondentAppears: {
      respondentAppearenceDate: "",
    },
  },

  whichFiling: -1,

  dissolveMarriage: {
    dissolveMarriageStatus: -1,
    sixMonth: {
      sixMonthDate: "",
    }
  },


  minorChildAgreement: {

    minorChildStatus: -1,

    childBornBefore: {
      childBornBeforeStatus: -1,
      completeOneStatus: -1,

      percentagePrevoiuslySet: {
        county: "",
        caseNumber: "",
      },

      childBornBeforeNo: {
        ChangeInFL_105Status: -1,
      },
    },

    courtCustodyCase: {
      courtCustodyCaseStatus: -1,
      courtCustodyCaseYes: {
        court: " ",
        county: "",
        caseNumber: "",
      },
    },

    enforcedInOtherCase: {
      enforcedInOtherCaseStatus: -1,
      enforcedInOtherCaseYes: {
        court: " ",
        county: "",
        caseNumber: "",
      },

      enforcedInOtherCaseNo: {
        selectionStatus: -1,
        selectionNo: {
          spouseStatus: -1,
          provideFacts: "",
        },
      },
    },

    publicAssitance: {
      publicAssitanceFirstStatus: -1,
      publicAssitanceSecondStatus: -1,
      publicAssitanceThird: -1,
    },
  },



  spousalSupportMSA: {
    spousalSupportMSAStatus: -1,
    spousalSupportMSANo: {
      allOptionMSAStatus: -1,
      spouseTerminatesStatus: -1,
      spousalSupportFromRespondent: "",
      spousalSupportFromPetitioner: "",
      otherRequest: "",
    },
  },
  changeFormerName: {
    changeFormerNameStatus: -1,
    changeFormerNameYes: {
      isSpouseStatus: -1,
      name: "",
    },
  },
};

const JudgementPacketFormsReducer = (state = initialState, action) => {
  switch (action.type) {

    case "REQUEST_POST_JUDGEMENT_FORM":
      return { ...state, isFetchingGetJugdementFormData: true };
    case "SUCCESS_POST_JUDGEMENT_FORM":
      return { ...state, isFetchingGetJugdementFormData: false };
    case "ERROR_POST_JUDGEMENT_FORM":
      return { ...state, isFetchingGetJugdementFormData: true };


    case "REQUEST_GET_JUDGEMENT_FORM_DATA":
      return {
        ...state, isFetchingPostJugdementForm: false,
        isFetchingGetJugdementFormData: true,
        isFetchingAreYouPetitioner: false,
        isFetchingSpouseMilitaryMember: false,
        isFetchingRespondentAppears: false,
        isFetchingFinalDeclarations: false,
        isFetchingAmendPetition: false,
        isFetchingEventHappnedFirst: false,
        isFetchingWhichFiling: false,
        isFetchingDissolveMarriage: false,
        isFetchingMinorChildAgreement: false,
        isFetchingSpousalSupportMSA: false,
        isFetchingChangeFormerName: false,
        isFetchNumberPagesAttached: false,

        spouseMilitaryMember: -1,
        numberPagesAttached: '',

        respondentAppears: {
          respondentAppearsStatus: -1,
          respondentAppearsNo: {
            divorcePurposeStatus: -1,
            divorcePurposeNo: {
              startOverInterviewStatus: -1,
              startOverInterviewNo: {
                settlementAgreementStatus: -1,
                settlementAgreementNo: {
                  legalProfessionalStatus: -1,
                },
              },
            },
          },
        },

        finalDeclarations: -1,

        amendPetition: -1,

        eventHappnedFirst: {
          eventHappnedFirstStatus: -1,
          respondentServed: {
            respondentServedDate: "",
          },
          respondentAppears: {
            respondentAppearenceDate: "",
          },
        },

        whichFiling: -1,

        dissolveMarriage: {
          dissolveMarriageStatus: -1,
          sixMonth: {
            sixMonthDate: "",
          }
        },

        minorChildAgreement: {

          minorChildStatus: -1,

          childBornBefore: {
            childBornBeforeStatus: -1,
            completeOneStatus: -1,

            percentagePrevoiuslySet: {
              county: "",
              caseNumber: "",
            },

            childBornBeforeNo: {
              ChangeInFL_105Status: -1,
            },
          },

          courtCustodyCase: {
            courtCustodyCaseStatus: -1,
            courtCustodyCaseYes: {
              court: " ",
              county: "",
              caseNumber: "",
            },
          },

          enforcedInOtherCase: {
            enforcedInOtherCaseStatus: -1,
            enforcedInOtherCaseYes: {
              court: " ",
              county: "",
              caseNumber: "",
            },

            enforcedInOtherCaseNo: {
              selectionStatus: -1,
              selectionNo: {
                spouseStatus: -1,
                provideFacts: "",
              },
            },
          },

          publicAssitance: {
            publicAssitanceFirstStatus: -1,
            publicAssitanceSecondStatus: -1,
            publicAssitanceThird: -1,
          },
        },

        spousalSupportMSA: {
          spousalSupportMSAStatus: -1,
          spousalSupportMSANo: {
            allOptionMSAStatus: -1,
            spouseTerminatesStatus: -1,
            spousalSupportFromRespondent: "",
            spousalSupportFromPetitioner: "",
            otherRequest: "",
          },
        },
        changeFormerName: {
          changeFormerNameStatus: -1,
          changeFormerNameYes: {
            isSpouseStatus: -1,
            name: "",
          },
        }
      };
    case "SUCCESS_GET_JUDGEMENT_FORM_DATA":
      return {
        ...state,
        spouseMilitaryMember: action.payload.data.spouseMilitaryMember,
        respondentAppears: {
          respondentAppearsStatus: action.payload.data.respondentAppears.respondentAppearsStatus,
          respondentAppearsNo: {
            divorcePurposeStatus: action.payload.data.respondentAppears.respondentAppearsNo.divorcePurposeStatus,
            divorcePurposeNo: {
              startOverInterviewStatus: action.payload.data.respondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewStatus,
              startOverInterviewNo: {
                settlementAgreementStatus: action.payload.data.respondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementStatus,
                settlementAgreementNo: {
                  legalProfessionalStatus: action.payload.data.respondentAppears.respondentAppearsNo.divorcePurposeNo.startOverInterviewNo.settlementAgreementNo.legalProfessionalStatus,
                },
              },
            },
          },
        },

        finalDeclarations: action.payload.data.finalDeclarations,

        amendPetition: action.payload.data.amendPetition,

        eventHappnedFirst: {
          eventHappnedFirstStatus: action.payload.data.eventHappnedFirst.eventHappnedFirstStatus,
          respondentServed: {
            respondentServedDate: action.payload.data.eventHappnedFirst.respondentServed.respondentServedDate,
          },
          respondentAppears: {
            respondentAppearenceDate: action.payload.data.eventHappnedFirst.respondentAppears.respondentAppearenceDate,
          },
        },

        whichFiling: action.payload.data.whichFiling,

        dissolveMarriage: {
          dissolveMarriageStatus: action.payload.data.dissolveMarriage.dissolveMarriageStatus,
          sixMonth: {
            sixMonthDate: action.payload.data.dissolveMarriage.sixMonth.sixMonthDate,
          }
        },

        spousalSupportMSA: {
          spousalSupportMSAStatus: action.payload.data.spousalSupportMSA.spousalSupportMSAStatus,
          spousalSupportMSANo: {
            allOptionMSAStatus: action.payload.data.spousalSupportMSA.spousalSupportMSANo.allOptionMSAStatus,
            spouseTerminatesStatus: action.payload.data.spousalSupportMSA.spousalSupportMSANo.spouseTerminatesStatus,
            spousalSupportFromRespondent: action.payload.data.spousalSupportMSA.spousalSupportMSANo.spousalSupportFromRespondent,
            spousalSupportFromPetitioner: action.payload.data.spousalSupportMSA.spousalSupportMSANo.spousalSupportFromPetitioner,
            otherRequest: action.payload.data.spousalSupportMSA.spousalSupportMSANo.otherRequest,
          },
        },
        changeFormerName: {
          changeFormerNameStatus: action.payload.data.changeFormerName.changeFormerNameStatus,
          changeFormerNameYes: {
            isSpouseStatus: action.payload.data.changeFormerName.changeFormerNameYes.isSpouseStatus,
            name: action.payload.data.changeFormerName.changeFormerNameYes.name,
          },
        },


        minorChildAgreement: {

          minorChildStatus: action.payload.data.minorChildAgreement.minorChildStatus,

          childBornBefore: action.payload.data.minorChildAgreement.childBornBefore,

          courtCustodyCase: action.payload.data.minorChildAgreement.courtCustodyCase,

          enforcedInOtherCase: action.payload.data.minorChildAgreement.enforcedInOtherCase,

          publicAssitance: action.payload.data.minorChildAgreement.publicAssitance,
        },

        isFetchingGetJugdementFormData: false
      };
    case "ERROR_GET_JUDGEMENT_FORM_DATA":
      return { ...state, isFetchingGetJugdementFormData: true };


    case "REQUEST_IS_PETITIONER":
      return { ...state, isFetchingAreYouPetitioner: true };
    case "SUCCESS_IS_PETITIONER":
      return {
        ...state,
        areYouPetitioner: action.payload.petitionerCheck,
        isFetchingAreYouPetitioner: false
      };
    case "ERROR_IS_PETITIONER":
      return { ...state, isFetchingAreYouPetitioner: true };


    case "REQUEST_IS_MILITARY_MEMBER":
      return { ...state, isFetchingSpouseMilitaryMember: true };
    case "SUCCESS_IS_MILITARY_MEMBER":
      return {
        ...state,
        spouseMilitaryMember: action.payload.isRespondent,
        isFetchingSpouseMilitaryMember: false
      };
    case "ERROR_IS_MILITARY_MEMBER":
      return { ...state, isFetchingSpouseMilitaryMember: true };


    case "SUCCESS_NUMBER_PAGES_ATTACHED":
      return {
        ...state,
        numberPagesAttached: Number(action.payload.numberPagesAttached), isFetchNumberPagesAttached: false,
      };

    case "REQUEST_FINAL_DECLARATIONS":
      return { ...state, isFetchingFinalDeclarations: true };
    case "SUCCESS_FINAL_DECLARATIONS":
      return {
        ...state,
        finalDeclarations: action.payload.finalDeclarations,
        isFetchingFinalDeclarations: false
      };
    case "ERROR_FINAL_DECLARATIONS":
      return { ...state, isFetchingFinalDeclarations: true };


    case "REQUEST_AMEND_PETITION":
      return { ...state, isFetchingAmendPetition: true };
    case "SUCCESS_AMEND_PETITION":
      return {
        ...state,
        amendPetition: action.payload.spouseAmendPettition,
        isFetchingAmendPetition: false
      };
    case "ERROR_AMEND_PETITION":
      return { ...state, isFetchingAmendPetition: true };



    case "REQUEST_EVENT_HAPPENED":
      return { ...state, isFetchingPostJugdementForm: true };
    case "SUCCESS_EVENT_HAPPENED":
      return {
        ...state,
        eventHappnedFirst: {
          eventHappnedFirstStatus: action.payload.eventStatus,
          respondentServed: {
            respondentServedDate: action.payload.respondentServedDate,
          },
          respondentAppears: {
            respondentAppearenceDate: action.payload.respondentAppearsDate,
          },
        },
        isFetchingPostJugdementForm: false
      };
    case "ERROR_EVENT_HAPPENED":
      return { ...state, isFetchingPostJugdementForm: true };


    case "REQUEST_FILING_COMPELETING":
      return { ...state, isFetchingWhichFiling: true };
    case "SUCCESS_FILING_COMPELETING":
      return {
        ...state,
        whichFiling: action.payload.filling_complete,
        isFetchingWhichFiling: false
      };
    case "ERROR_FILING_COMPELETING":
      return { ...state, isFetchingWhichFiling: true };

    case "REQUEST_DISSOLVING_MARRIAGE":
      return { ...state, isFetchingDissolveMarriage: true };
    case "SUCCESS_DISSOLVING_MARRIAGE":
      return {
        ...state,
        dissolveMarriage: {
          dissolveMarriageStatus: action.payload.statusDivorce,
          sixMonth: {
            sixMonthDate: action.payload.enterDate,
          }
        },
        isFetchingDissolveMarriage: false
      };
    case "ERROR_DISSOLVING_MARRIAGE":
      return { ...state, isFetchingDissolveMarriage: true };


    case "REQUEST_RESPONDENT_APPEARS":
      return { ...state, isFetchingRespondentAppears: true };
    case "SUCCESS_RESPONDENT_APPEARS":
      return {
        ...state,
        respondentAppears: {
          respondentAppearsStatus: action.payload.respondentFilled,
          respondentAppearsNo: {
            divorcePurposeStatus: action.payload.respondentAppearance,
            divorcePurposeNo: {
              startOverInterviewStatus: action.payload.startInterview,
              startOverInterviewNo: {
                settlementAgreementStatus: action.payload.respondentSettlement,
                settlementAgreementNo: {
                  legalProfessionalStatus: action.payload.interview,
                },
              },
            },
          },
        },
        isFetchingRespondentAppears: false
      };
    case "ERROR_RESPONDENT_APPEARS":
      return { ...state, isFetchingRespondentAppears: true };

    case "REQUEST_HAVE_SPOUSAL_SUPPORT":
      return { ...state, isFetchingPostJugdementForm: true };
    case "SUCCESS_HAVE_SPOUSAL_SUPPORT":
      return {
        ...state,
        spousalSupportMSA: {
          spousalSupportMSAStatus: action.payload.spousalSupport,
          spousalSupportMSANo: {
            allOptionMSAStatus: action.payload.waivSpousal,
            spouseTerminatesStatus: action.payload.spouseTerminates,
            spousalSupportFromRespondent: action.payload.petitionerReserves,
            spousalSupportFromPetitioner: action.payload.respondentReserves,
            otherRequest: action.payload.otherRequest,
          },
        },
        isFetchingPostJugdementForm: false
      };
    case "ERROR_HAVE_SPOUSAL_SUPPORT":
      return { ...state, isFetchingPostJugdementForm: true };


    case "REQUEST_CHANGE_FORMER_NAME":
      return { ...state, isFetchingChangeFormerName: true };
    case "SUCCESS_CHANGE_FORMER_NAME":
      return {
        ...state,
        changeFormerName: {
          changeFormerNameStatus: action.payload.yesNo,
          changeFormerNameYes: {
            isSpouseStatus: action.payload.petiRes,
            name: action.payload.lastname,
          },
        },
        isFetchingChangeFormerName: false
      };
    case "ERROR_CHANGE_FORMER_NAME":
      return { ...state, isFetchingChangeFormerName: true };


    case "REQUEST_HAVE_MINOR_CHILD":
      return { ...state, isFetchingMinorChildAgreement: true };
    case "SUCCESS_HAVE_MINOR_CHILD":
      return {
        ...state,

        minorChildAgreement: {

          minorChildStatus: action.payload.minor_children_agreement,

          childBornBefore: {
            childBornBeforeStatus: action.payload.prior_mirrage,
            completeOneStatus: action.payload.child_new_information,

            percentagePrevoiuslySet: {
              county: action.payload.county,
              caseNumber: action.payload.case_number,
            },

            childBornBeforeNo: {
              ChangeInFL_105Status: action.payload.information_entered_uccjea,
            },
          },

          courtCustodyCase: {
            courtCustodyCaseStatus: action.payload.existing_court_order_custody,
            courtCustodyCaseYes: {
              court: action.payload.petiRes,
              county: action.payload.petiRes,
              caseNumber: action.payload.petiRes,
            },
          },

          enforcedInOtherCase: {
            enforcedInOtherCaseStatus: action.payload.child_support_enforce,
            enforcedInOtherCaseYes: {
              court: action.payload.child_support_court,
              county: action.payload.child_support_county,
              caseNumber: action.payload.child_support_case_number,
            },

            enforcedInOtherCaseNo: {
              selectionStatus: action.payload.select_one,
              selectionNo: {
                spouseStatus: action.payload.your_spouse,
                provideFacts: action.payload.spouse_earning_ability,
              },
            },
          },

          publicAssitance: {
            publicAssitanceFirstStatus: action.payload.public_assistance,
            publicAssitanceSecondStatus: action.payload.best_my_knowledge,
            publicAssitanceThird: action.payload.party_receiving,
          },
        },

        isFetchingMinorChildAgreement: false
      };
    case "ERROR_HAVE_MINOR_CHILD":
      return { ...state, isFetchingMinorChildAgreement: true };



    default:
      return state;
  }
};
export default JudgementPacketFormsReducer;
